export const variables = {
	USER_LOCALSTORAGE: "USER_LOCALSTORAGE",
	FAVORITES_LOCALSTORAGE: "FAVORITES_LOCALSTORAGE",
	WATCHED_LOCALSTORAGE: "WATCHED_LOCALSTORAGE",
};
